<div
  class="w-24 rounded-md border-2 border-solid px-2 py-1 text-center text-xs font-bold"
  [matTooltip]="status | map: getTooltip : this"
  [ngClass]="status | map: getColour : this"
>
  {{ status | uppercase }}
</div>
